import logo3la from '@/assets/logos/3LALabs.png';
import { appConfig } from '@/config';
import { cn } from '@/utils/cn';

export function SidebarFooter({ collapsed }) {
  const fullLabel = `Versão ${appConfig.version}`;
  const versionText = collapsed ? appConfig.version : fullLabel;

  return (
    <footer
      className={cn(
        'flex shrink-0 flex-col items-center border-t border-white/10 px-3 py-3 text-center text-[11px] leading-relaxed text-[var(--sidebar-foreground)]/55',
        collapsed && 'px-0',
      )}
    >
      <p className="w-full tabular-nums" title={fullLabel}>
        {versionText}
      </p>

      <a
        href={appConfig.developer.url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Desenvolvido por ${appConfig.developer.name}`}
        className={cn(
          'group mt-2 inline-flex items-center justify-center gap-2 transition-opacity hover:opacity-100',
          collapsed ? 'opacity-70' : 'opacity-100',
        )}
      >
        {!collapsed ? <span className="text-[10px] tracking-wide">Desenvolvido por</span> : null}
        <img
          src={logo3la}
          alt={appConfig.developer.name}
          className={cn(
            'w-auto opacity-80 transition duration-200 group-hover:scale-105 group-hover:opacity-100',
            collapsed ? 'h-4' : 'h-5',
          )}
        />
      </a>
    </footer>
  );
}
